export default __webpack_public_path__ + "static/postgre-sql-283f4d16765dbef1a49808f5d1627097.svg";